import { useContext, useEffect, useState } from "react";
import "../../Style/NewCompanyStyle.scss";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { LinkAndClickButton } from "../../Components/AddElementsButton";
import { FaTimes } from "react-icons/fa";
import { getSystemPackage } from "../../GetData/SystemPackage";
import { getSystemModules } from "../../GetData/SystemModules";
import { getSystemLicenseTypes } from "../../GetData/LicenseType";
import { getLicenseStatus } from "../../GetData/LicenseStatus";
import { getLicensePaymentStatus } from "../../GetData/LicensePaymentType";
// import {
//   LICENSE_TYPES,
//   PAYMENT_STATUS,
//   LICENSE_STATUS,
// } from "../../OtherData/LicenseData";

export default function NewCompany() {
  const headers = authHeader();
  const year = new Date().getFullYear();
  const { fiscalYear } = useContext(FiscalYearContext);
  const [disableForm, setDisableForm] = useState(false);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  // Company states
  const [companyName, setCompanyName] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [adress, setAdress] = useState("");
  const [cityID, setCityID] = useState("");
  const [stateID, setStateID] = useState();
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [ediPass, setEdiPass] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [vATDeclarant, setvATDeclarant] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [arbkPass, setArbkPass] = useState("");
  const [mailPass, setMailPass] = useState("");
  const [smtpClient, setSmtpClient] = useState("");

  // License states
  const [licenseTypeID, setLicenseTypeID] = useState();
  const [packageID, setPackageID] = useState("");
  const [moduleID, setModuleID] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState("");
  const [statusID, setStatusID] = useState("");
  const [paymentStatusID, setPaymentStatusID] = useState("");
  const [licenseComment, setLicenseComment] = useState("");

  const [states, setStates] = useState([]);
  const [city, setCity] = useState([]);
  const [pack, setPack] = useState([]);
  const [module, setModule] = useState([]);
  const [accountantUser, setAccountantUser] = useState([]);

  const [licenseTypes, setLicenseTypes] = useState([]);
  const [licensesStatus, setLicensesStatus] = useState([]);
  const [licensePaymentType, setLicensePaymentType] = useState([]);

  const [accountantUserID, setAccountantUserID] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userComment, setUserComment] = useState("");

  //Pjesa per select input field users
  const [userName, setUserName] = useState("");
  const handleAutocompleteChangeUser = (event, value) => {
    if (value && value.Id) {
      setAccountantUserID(value.Id);
      setUserName(value);
    } else {
      // Në rast se vlera është pastruar
      setAccountantUserID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsUser = {
    options: accountantUser,
    getOptionLabel: (option) => `${option.UserName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.UserName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field states
  const [stateName, setStateName] = useState("");
  const handleAutocompleteChangeState = (event, value) => {
    if (value && value.StateID) {
      setStateID(value.StateID);
      setStateName(value);
      fetchCityByState(value.StateID);
    } else {
      // Në rast se vlera është pastruar
      setStateID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsStates = {
    options: states,
    getOptionLabel: (option) => `${option.StateName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StateName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field city
  const [cityName, setCityName] = useState("");
  const handleAutocompleteChangeCity = (event, value) => {
    if (value && value.CityID) {
      setCityID(value.CityID);
      setCityName(value);
    } else {
      // Në rast se vlera është pastruar
      setCityID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsCities = {
    options: city,
    getOptionLabel: (option) => `${option.CityName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.CityName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  // const completeData = (id) => {
  //   if (id === 4) {
  //     setStatusID(4);
  //     setPaymentStatusID(4);
  //   } else if (id === 5) {
  //     setStatusID(5);
  //     setPaymentStatusID(5);
  //   }
  // };

  //Pjesa per select input field licenseType
  const [licenseType, setLiceseType] = useState(null);
  const handleAutocompleteChangeLicenseType = (event, value) => {
    if (value && value.DurationTypeID) {
      setLicenseTypeID(value.DurationTypeID);
      setLiceseType(value);
      // kalkulo endDate automatikisht
      const calculatedEnd = calculateEndDate(value.DurationDays);
      setEndDate(calculatedEnd);
      // completeData(value.DurationTypeID);
    } else {
      // nëse pastrohet
      setLicenseTypeID("");
      setLiceseType(null);
      setEndDate("");
    }
  };

  const defaultPropsLicenseType = {
    options: licenseTypes,
    getOptionLabel: (option) => `${option.DurationName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.DurationName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [licenseType, setLiceseType] = useState("");
  // const handleAutocompleteChangeLicenseType = (event, value) => {
  //   if (value && value.DurationTypeID) {
  //     setLicenseTypeID(value.id);
  //     setLiceseType(value);
  //     // kalkulo endDate automatikisht
  //     const calculatedEnd = calculateEndDate(value.value);
  //     setEndDate(calculatedEnd);
  //     completeData(value.id);
  //   } else {
  //     // nëse pastrohet
  //     setLicenseTypeID("");
  //     setLiceseType(null);
  //     setEndDate("");
  //   }
  // };

  // const defaultPropsLicenseType = {
  //   options: LICENSE_TYPES,
  //   getOptionLabel: (option) => `${option.label}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.label}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field licenseStatus
  const [licenseStatus, setLiceseStatus] = useState(null);
  const handleAutocompleteChangeLicenseStatus = (event, value) => {
    if (value && value.LicenseStatusID) {
      setStatusID(value.LicenseStatusID);
      setLiceseStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsLicenseStatus = {
    options: licensesStatus,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [licenseStatus, setLiceseStatus] = useState("");
  // const handleAutocompleteChangeLicenseStatus = (event, value) => {
  //   if (value && value.id) {
  //     setStatusID(value.id);
  //     setLiceseStatus(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setStatusID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsLicenseStatus = {
  //   options: LICENSE_STATUS,
  //   getOptionLabel: (option) => `${option.label}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.label}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field paymentStatus
  const [paymentStatus, setPaymentStatus] = useState("");
  const handleAutocompleteChangePaymentStatus = (event, value) => {
    if (value && value.PaymentStatusID) {
      setPaymentStatusID(value.PaymentStatusID);
      setPaymentStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setPaymentStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsPaymentStatus = {
    options: licensePaymentType,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [paymentStatus, setPaymentStatus] = useState("");
  // const handleAutocompleteChangePaymentStatus = (event, value) => {
  //   if (value && value.id) {
  //     setPaymentStatusID(value.id);
  //     setPaymentStatus(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setPaymentStatusID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsPaymentStatus = {
  //   options: PAYMENT_STATUS,
  //   getOptionLabel: (option) => `${option.label}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.label}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field pack
  const [packageType, setPackageType] = useState(null);
  const [packageField, setPackageField] = useState(null);
  const handleAutocompleteChangePackageType = (event, value) => {
    if (value && value.PackageID) {
      setPackageID(value.PackageID);
      setPackageType(value.PackageName);
      setPackageField(value);
    } else {
      // Në rast se vlera është pastruar
      setLicenseTypeID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsPackageType = {
    options: pack,
    getOptionLabel: (option) => `${option.PackageName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.PackageName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [packageType, setPackageType] = useState(null);
  // const [packageField, setPackageField] = useState(null);
  // const handleAutocompleteChangePackageType = (event, value) => {
  //   if (value && value.PackID) {
  //     setPackageID(value.PackID);
  //     setPackageType(value.PackName);
  //     setPackageField(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setLicenseTypeID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsPackageType = {
  //   options: pack,
  //   getOptionLabel: (option) => `${option.PackName}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.PackName}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field module
  const [moduleType, setModuleType] = useState(null);
  const [moduleField, setModuleField] = useState(null);
  const handleAutocompleteChangeModuleType = (event, value) => {
    if (value && value.ModuleID) {
      //   setModuleID(value.PackID);
      setModuleType(value.ModuleCode);
      setModuleField(value);
    } else {
      // Në rast se vlera është pastruar
      //   setModuleID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsModuleType = {
    options: module,
    getOptionLabel: (option) => `${option.ModuleName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.ModuleName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [moduleType, setModuleType] = useState(null);
  // const [moduleField, setModuleField] = useState(null);
  // const handleAutocompleteChangeModuleType = (event, value) => {
  //   if (value && value.PackID) {
  //     setModuleID(value.PackID);
  //     setModuleType(value.PackName);
  //     setModuleField(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setModuleID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsModuleType = {
  //   options: module,
  //   getOptionLabel: (option) => `${option.PackName}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.PackName}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const stateData = {
      CompanyName: companyName,
      IdentificationNumber: identificationNumber,
      VATNumber: vatNumber,
      Address: adress,
      CityID: cityID,
      StateID: stateID,
      PhoneNumbers: phoneNumbers,
      EdiPass: ediPass,
      Email: email,
      Comment: comment,
      // CreatedByUser: loginEmail,
      VATDeclarant: vATDeclarant,
      FiscalYear: year,
      IsActive: isActive,
      ARBKPass: arbkPass,
      MailPass: mailPass,
      SMTPClient: smtpClient,
    };
    axios
      .post(ApiLink.API_URL + "Companies", stateData, { headers })
      .then((response) => {
        handleSuccess("Company Added Successfully");
        setDisableForm(true);
        setLoading(false);
        setStep(2); // Move to License Form
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        setDisableForm(false);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
          setLoading(false);
          setDisableForm(false);
        } else {
          errorAlert("An unknown error occurred while processing the request.");
          setLoading(false);
          setDisableForm(false);
        }
      });
  };

  const handleSubmitLicense = (event) => {
    event.preventDefault();
    setLoading(true);

    const stateData = {
      LicenseTypeID: licenseTypeID,
      PackageID: packageID,
      StartDate: startDate,
      EndDate: endDate,
      Status: statusID,
      PaymentStatus: paymentStatusID,
      Comment: licenseComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newLicense", stateData, {
        headers,
        params: { identificationNumber: identificationNumber },
      })
      .then((response) => {
        handleSuccess("Licensa u gjenerua me sukses");
        setLoading(false);
        handleUpdateCompanyPack();
        if (licenseTypeID === 5) {
          setStep(3); // Move to accountant Form
        } else {
          setStep(4); // Move to final Form
        }
      })
      .catch((error) => {
        setLoading(false);
        setDisableForm(false);
        if (error.response) {
          // Server ktheu një përgjigje (jo 2xx)
          if (error.response.data) {
            errorAlert(
              `Gabim nga serveri: ${error.response.status}\n` +
                `Detaje: ${JSON.stringify(error.response.data)}`
            );
          } else {
            errorAlert(`Gabim nga serveri: ${error.response.status}`);
          }
        } else if (error.request) {
          // Request u dërgua, por nuk erdhi përgjigje
          errorAlert("Serveri nuk u përgjigj fare. Kontrollo lidhjen.");
        } else {
          // Error tjetër në konfigurim ose ekzekutim
          errorAlert("Gabim gjatë konfigurimit të kërkesës: " + error.message);
        }
      });
  };

  const handleUpdateCompanyPack = () => {
    const updateData = {
      Pack: packageType,
      Module: moduleType,
    };

    // axios.put(ApiLink.API_URL + 'PackContoller', updateData, { headers })
    axios
      .put(ApiLink.API_URL + "PackContoller/packForCompany", updateData, {
        headers,
        params: { identificationNumber: identificationNumber },
      })
      .then((response) => {
        if (response.status === 200) {
          // handleSuccess(response.data); // Shfaq mesazhin e suksesit
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 400) {
            errorAlert(
              "Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri."
            );
          } else if (error.response.status === 500) {
            errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
          } else {
            errorAlert("Gabim i panjohur: " + error.response.data);
          }
        } else {
          errorAlert(
            "Nuk mund të lidhemi me serverin. Ju lutem provoni më vonë."
          );
        }
      });
  };

  const handleSubmitAccountant = (event) => {
    event.preventDefault();
    setLoading(true);

    const stateData = {
      UserID: accountantUserID,
      IPAddress: ipAddress,
      Comment: userComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newFreeManagementAccount", stateData, {
        headers,
        params: { identificationNumber: identificationNumber },
      })
      .then((response) => {
        handleSuccess("Llogaria u shtua tek lista e kontabilistit");
        setStep(4); // Move to final Form
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          // Server ktheu një përgjigje (jo 2xx)
          if (error.response.data) {
            errorAlert(
              `Gabim nga serveri: ${error.response.status}\n` +
                `Detaje: ${JSON.stringify(error.response.data)}`
            );
          } else {
            errorAlert(`Gabim nga serveri: ${error.response.status}`);
          }
        } else if (error.request) {
          // Request u dërgua, por nuk erdhi përgjigje
          errorAlert("Serveri nuk u përgjigj fare. Kontrollo lidhjen.");
        } else {
          // Error tjetër në konfigurim ose ekzekutim
          errorAlert("Gabim gjatë konfigurimit të kërkesës: " + error.message);
        }
      });
  };

  const fetchCityByState = async (selectedStateID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Cities/getcitybystate",
        { headers, params: { stateid: selectedStateID } }
      );
      setCity(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "states", { headers })
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // const fetchPack = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "pako" },
  //     });
  //     setPack(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  // const fetchModule = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "modul" },
  //     });
  //     setModule(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  const fetchUser = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Users/getAccountantUser",
        { headers }
      );
      setAccountantUser(response.data);
      setLoading(false);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const calculateEndDate = (durationDays) => {
    // startDate është gjithmonë data e sotme
    const start = new Date();

    // endDate = startDate + durationDays
    const end = new Date(start);
    end.setDate(start.getDate() + Number(durationDays));

    // kthe format YYYY-MM-DD
    return end.toISOString().split("T")[0];
  };

  // const calculateEndDate = (type) => {
  //   const today = new Date(startDate);
  //   const end = new Date(today);

  //   switch (type) {
  //     case "trial":
  //     case "weekly":
  //       end.setDate(today.getDate() + 7);
  //       break;
  //     case "monthly":
  //       end.setMonth(today.getMonth() + 1);
  //       break;
  //     case "yearly":
  //     case "accountant":
  //       end.setFullYear(today.getFullYear() + 1);
  //       break;
  //     default:
  //       end.setDate(today.getDate());
  //   }

  //   return end.toISOString().split("T")[0]; // format YYYY-MM-DD
  // };

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    if (fiscalYear === year) {
      setStartDate(formattedDate);
    } else {
      setStartDate("");
    }
  }, [fiscalYear]);

  const loaddata = async () => {
    try {
      const [
        packagesType,
        modules,
        licenseType,
        licenseStatus,
        licensePaymentType,
      ] = await Promise.all([
        getSystemPackage(headers),
        getSystemModules(headers),
        getSystemLicenseTypes(headers),
        getLicenseStatus(headers),
        getLicensePaymentStatus(headers),
      ]);

      if (packagesType) setPack(packagesType);
      if (modules) setModule(modules);
      if (licenseType) setLicenseTypes(licenseType);

      console.log(licenseType);
      if (licenseStatus) setLicensesStatus(licenseStatus);
      if (licensePaymentType) setLicensePaymentType(licensePaymentType);
    } catch (error) {}
  };

  useEffect(() => {
    // fetchPack();
    fetchUser();
    loaddata();

    // fetchModule();
  }, []);
  return (
    <div className="form-container">
      {/* Progress */}
      <div className="progress">
        <div className={`step ${step >= 1 ? "active" : ""}`}>
          <div className="circle">{step > 1 ? "✓" : "1"}</div>
          <span>Informatat e Kompanisë</span>
        </div>
        <div className="arrow">→</div>
        <div className={`step ${step >= 2 ? "active" : ""}`}>
          <div className="circle">{step > 2 ? "✓" : "2"}</div>
          <span>Gjenerimi i Licensës</span>
        </div>
        {step === 3 ? (
          <>
            <div className="arrow">→</div>
            <div className={`step ${step >= 3 ? "active" : ""}`}>
              <div className="circle">3</div>
              <span>Informata të kontabilistit</span>
            </div>
          </>
        ) : null}
        {step === 4 ? (
          <>
            <div className="arrow">→</div>
            <div className={`step ${step >= 4 ? "active" : ""}`}>
              <div className="circle">{step > 3 ? "✓" : ""}</div>
              <span>Konfirmim</span>
            </div>
          </>
        ) : null}
      </div>

      {/* Step 1 */}
      {step === 1 && (
        <form className="card" onSubmit={handleSubmit}>
          <h2>Hapi 1:Informatat e Kompanisë</h2>
          <div className="form-grid">
            <TextField
              className="class__Fields"
              required
              id="outlined-required"
              label="Emri i Kompanisë"
              value={companyName}
              onChange={(event) => setCompanyName(event.target.value)}
              autoComplete="off"
              disabled={disableForm}
            />
            <div className="form-grid-fields">
              <TextField
                className="class__Fields"
                required
                id="outlined-required"
                label="Numri Identifikues"
                value={identificationNumber}
                onChange={(event) =>
                  setIdentificationNumber(event.target.value)
                }
                autoComplete="off"
                disabled={disableForm}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="Numri i TVSH-së"
                value={vatNumber}
                onChange={(event) => setVatNumber(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />
            </div>
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsStates}
                id="include-input-in-list"
                includeInputInList
                value={stateName} // stateName fillimisht ""
                getOptionLabel={(option) => option.StateName || ""}
                onChange={handleAutocompleteChangeState}
                autoComplete="off"
                disabled={disableForm}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh shtetin"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
              <Autocomplete
                className="class__Fields"
                {...defaultPropsCities}
                id="include-input-in-list"
                includeInputInList
                value={cityName}
                getOptionLabel={(option) => option.CityName || ""}
                onChange={handleAutocompleteChangeCity}
                autoComplete="off"
                disabled={disableForm}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh Qytetin"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
              <TextField
                className="class__Fields"
                id="outlined-required"
                label="Adresa"
                value={adress}
                onChange={(event) => setAdress(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />
            </div>
            <div className="form-grid-fields">
              <TextField
                className="class__Fields"
                id="outlined-required"
                label="Numri Telefonit"
                value={phoneNumbers}
                onChange={(event) => setPhoneNumbers(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="SMTP Client"
                name="SMTPClient"
                value={smtpClient}
                onChange={(event) => setSmtpClient(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />
            </div>

            <div className="form-grid-fields">
              <TextField
                className="class__Fields"
                id="outlined-required"
                label="Fjalkalimi i Email-it "
                value={mailPass}
                onChange={(event) => setMailPass(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="Fjalkalimi i sistemit të ATK-së"
                value={ediPass}
                onChange={(event) => setEdiPass(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="Fjalkalimi i sistemit të ARBK-së"
                value={arbkPass}
                onChange={(event) => setArbkPass(event.target.value)}
                autoComplete="off"
                disabled={disableForm}
              />
            </div>

            <label>
              Përshkrim
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows="2"
                autoComplete="off"
                disabled={disableForm}
              />
            </label>
            <div className="form-grid-fields">
              <label>
                Deklarues i TVSH-s
                <input
                  type="checkbox"
                  checked={vATDeclarant}
                  onChange={(e) => setvATDeclarant(e.target.checked)}
                  disabled={disableForm}
                />
              </label>
              <label>
                Statusi kompanis
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  disabled={disableForm}
                />
              </label>
            </div>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Duke u procesuar" : "Ruaj"}
          </button>
        </form>
      )}
      {/* Step 2 */}
      {step === 2 && (
        <form className="card" onSubmit={handleSubmitLicense}>
          <h2>Hapi 2: Gjenerimi i Licensës, për kompanin: {companyName}</h2>

          <div className="form-grid">
            <Autocomplete
              className="class__Fields"
              {...defaultPropsLicenseType}
              id="include-input-in-list"
              includeInputInList
              value={licenseType}
              getOptionLabel={(option) => option.DurationName || ""}
              onChange={handleAutocompleteChangeLicenseType}
              autoComplete="off"
              // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
              renderInput={(params) => (
                <TextField
                  // style={{ width: "95%" }}
                  {...params}
                  label="Zgjedh Llojin e licenses"
                  autoComplete="off"

                  // variant="filled"
                  //   onKeyPress={handleKeyPress}
                />
              )}
            />

            <div className="form-grid-fields">
              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data fillimir"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />

              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data mbarimit"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                // disabled={form1IsDisabled}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />
            </div>
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsPackageType}
                id="include-input-in-list"
                includeInputInList
                value={packageField}
                getOptionLabel={(option) => option.PackageName || ""}
                onChange={handleAutocompleteChangePackageType}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh Llojin e Pakos"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <Autocomplete
                className="class__Fields"
                {...defaultPropsModuleType}
                id="include-input-in-list"
                includeInputInList
                value={moduleField}
                getOptionLabel={(option) => option.ModuleName || ""}
                onChange={handleAutocompleteChangeModuleType}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh Modulin"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsLicenseStatus}
                id="include-input-in-list"
                includeInputInList
                // value={licenseStatus}
                value={
                  licensesStatus.find((option) => option.LicenseStatusID === statusID) ||
                  licenseStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangeLicenseStatus}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i licenses"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <Autocomplete
                className="class__Fields"
                {...defaultPropsPaymentStatus}
                id="include-input-in-list"
                includeInputInList
                // value={paymentStatus}
                value={
                  licensePaymentType.find(
                    (option) => option.PaymentStatusID === paymentStatusID
                  ) || paymentStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangePaymentStatus}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i pagesës"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <label>
              Përshkrim
              <textarea
                value={licenseComment}
                onChange={(e) => setLicenseComment(e.target.value)}
                rows="2"
              />
            </label>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Duke u procesuar..." : "Gjenero licensen"}
          </button>
        </form>
      )}

      {/* Step 3 */}
      {step === 3 && (
        <form className="card" onSubmit={handleSubmitAccountant}>
          <h2>Hapi 3: Informata për kontabilistin</h2>
          <div className="form-grid">
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsUser}
                id="include-input-in-list"
                includeInputInList
                value={userName}
                getOptionLabel={(option) => option.UserName || ""}
                onChange={handleAutocompleteChangeUser}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh përdoruesin"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="IP Adresa"
                value={ipAddress}
                onChange={(event) => setIpAddress(event.target.value)}
                autoComplete="off"
              />
            </div>
            <label>
              Përshkrim
              <textarea
                value={userComment}
                onChange={(e) => setUserComment(e.target.value)}
                rows="2"
              />
            </label>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Duke u procesuar..." : "Ruaj"}
          </button>
        </form>
      )}
      {step === 4 && (
        <form className="card" onSubmit={handleSubmitLicense}>
          <h2>Kompania e re u krijuar</h2>
          <LinkAndClickButton
            text="Kthehu tek lista e kompanive"
            icon={<FaTimes />}
            link="/configuration/company"
          />
        </form>
      )}
    </div>
  );
}
